export const CashCallFormInjectionKey = 'cash-call-form'
